import { useQuery } from "@tanstack/react-query";

import { get } from "api";
import Services from "services/Services";

export function useStripePublishableKey(): string | null {
  const { data } = useQuery({
    queryKey: [KEY],
    queryFn: async () => {
      const authToken = await Services.auth.getToken();

      if (!authToken) {
        return null;
      }

      return get(KEY);
    },
    retry: 3,
    retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 10000),
  });

  return data ?? null;
}

const KEY = "/stripe-keys/publishable-key";
